const TradingMentorSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4993 14.168V15.8346C17.4993 16.7551 16.7532 17.5013 15.8327 17.5013H14.166"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 7.5V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H5.83333"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33398 6.66667V4.16667C8.33398 3.24619 9.08018 2.5 10.0007 2.5H15.834C16.7545 2.5 17.5007 3.24619 17.5007 4.16667V10C17.5007 10.9205 16.7545 11.6667 15.834 11.6667H11.6673"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.834 5.83464H15.0007"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.666 8.33464H14.9993"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="6.66732"
      cy="11.2513"
      r="2.08333"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8333 17.5013C10.8333 16.3507 9.90059 15.418 8.75 15.418H4.58333C3.43274 15.418 2.5 16.3507 2.5 17.5013"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TradingMentorSvg;
